// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import { buttonResetProps } from "@store/Themes/common/props/button";
import { popoverStyles } from "@store/Themes/common/mixins/popover";
import { sideMenuLinkStyles, sideMenuWrapperStyles } from "@store/Themes/common/mixins/sidemenu";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { focusStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

const overflowMenu: Styleguide["overflowMenu"] = {
    defaultProps: {
        buttonProps: {
            ...buttonResetProps,
            css: css`
                ${buttonResetProps.css}
                transition: ${transitionHoverStyles("color")};

                &:hover,
                &:active,
                &:focus {
                    background: transparent;
                    border-color: transparent;
                }
                &[aria-expanded="true"] {
                    color: ${getColor("primary")};
                }
            `,
        },
        iconProps: {
            css: css`
                vertical-align: top;
                top: 0 !important;
            `,
        },
        cssOverrides: {
            wrapper: css`
                width: auto;
                height: auto;
            `,
            menu: css`
                ${sideMenuWrapperStyles()}
                ${popoverStyles()}
            `,
            menuItem: css`
                ${focusStyles(true)}
                display: flex;
                padding: ${pxToRem(10, 16, 11)};
                margin-top: -${pxToRem(1)};
                font-size: ${x => x.theme.design.typography.size.small};
                border-top: 1px solid ${getColor("common.border")};
                transition: ${transitionHoverStyles("color", "background-color")};
                font-weight: normal;
                color: inherit;
                text-decoration: none;

                &:hover,
                &:active,
                &:focus {
                    background-color: transparent;
                    text-decoration: none;
                    color: inherit;
                }
                ${sideMenuLinkStyles()}
                &:hover,
                &:active {
                    color: ${getColor("primary")};
                }
            `,
        },
    },
};

export default overflowMenu;
